import { useContext, useEffect, useRef, useState } from "react";
import "./styles.css";
import api from "../../../../services/axiosConfig";
import { toast } from "react-toastify";
import { Context } from "../../../../hooks/useAuthContext";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaEyeSlash, FaFileAlt, FaGlobe } from "react-icons/fa";

import ModalDocumentos from "../../../../components/ModalDocumentos/ModalDocumentos";
import { formatPhone } from "../../../../utils/telefoneFormatter";
import { formatCpfCnpj } from "../../../../utils/cpfCnpjFormatter";
import ModalMotivos from "../../../../components/ModalMotivos/ModalMotivos";
import Swal from "sweetalert2";
import { FiLock, FiSearch } from "react-icons/fi";
import ModalListaDeRedes from "../Usuários/components/ModalListaDeRedes/ModalListaDeRedes";

function Solicitacoes() {
  const { exibirLogs, userData } = useContext(Context);
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [sortField, setSortField] = useState("nome");
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalDocs, setTotalDocs] = useState(1);
  const [statusAprovacao, setStatusAprovacao] = useState("Análise");
  const [showDocsModal, setShowDocsModal] = useState(false);
  const [docFrente, setDocFrente] = useState("");
  const [docVerso, setDocVerso] = useState("");
  const [nome, setNome] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");

  const [showMotivoModal, setShowMotivoModal] = useState(false);
  const [uidParaReprovar, setUidParaReprovar] = useState(null);

  const [modalRedesAberto, setModalRedesAberto] = useState(false);
  const [redesSelecionadas, setRedesSelecionadas] = useState([]);
  const [usuarioParaRedes, setUsuarioParaRedes] = useState(null);

	const isInitialLoad = useRef(true);

  async function approveUser(uid) {
    Swal.fire({
      title: "Grupo do usuário",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
        placeholder: "Link do grupo (opcional)"
      },
      confirmButtonText: "Confirmar e aprovar",
      confirmButtonColor: "#3085d6",
      showLoaderOnConfirm: true,
      preConfirm: (groupLink) => {
        return groupLink;
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then(async (result) => {
      if (result.isConfirmed) {
        const linkGrupo = result.value;
        
        try {
                    
          const response = await api.put(`/admin/users/approve/${uid}`, {linkGrupo});
          
          exibirLogs && console.log(response.data);
          toast.success("Usuário aprovado!");

          await fetchData();
          return;
        } catch (error) {
          exibirLogs && console.error("Erro ao aprovar usuário:", error);
          toast.error("Erro ao aprovar usuário!");
        }
      }
    });
  }

  async function repproveUser(uid, motivo) {
    try {
      await api.put(`/admin/users/repprove/${uid}`, { motivo });
      toast.success("Usuário reprovado!");
      await fetchData();
    } catch (error) {
      exibirLogs && console.error(error);
      toast.error("Erro ao reprovar usuário!");
    }
  }

  async function fetchData() {
    try {
      const params = {
        statusAprovacao: statusAprovacao,
        search: search || undefined,
        page,
        limit,
        sortField,
        sortOrder,
				logAction: !isInitialLoad.current ? true : undefined,
      };

      const response = await api.get("/admin/users", { params });
      const users = response.data?.data;
      setTotalPages(response.data?.totalPages || 1);
      setTotalDocs(response.data?.total);
      setSolicitacoes(users);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar solicitações:", error);
    }
  }

  // Executado quando filtros, paginação ou ordenação mudam
  useEffect(() => {
    if (!isInitialLoad.current) {
      fetchData();
    }
  }, [statusAprovacao, page, sortField, sortOrder]);

  // Executado no carregamento inicial e quando a busca é limpa
	useEffect(() => {
    if (search === "") {
      fetchData();
    }
    
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    }
  }, [search]); 

  const handleOpenDocs = (frente, verso, nome, cpfCnpj) => {
    setDocFrente(frente);
    setDocVerso(verso);
    setNome(nome);
    setCpfCnpj(cpfCnpj);
    setShowDocsModal(true);
  };

  const handleAbrirModalRedes = (usuario) => {
    setRedesSelecionadas(usuario.redesSociais);
    setUsuarioParaRedes(usuario);
    setModalRedesAberto(true);
  };

  const handleSalvarRedes = async (novasRedes) => {
    if (!usuarioParaRedes) {
      toast.error("Nenhum usuário selecionado para atualizar as redes.");
      return;
    }

    const dadosAtualizados = {
      redesSociais: novasRedes,
    };

    try {
      await api.put(`/auth/user/update/${usuarioParaRedes.uid}`, dadosAtualizados);
      toast.success("Redes sociais atualizadas com sucesso!");
      setModalRedesAberto(false);
      await fetchData();
    } catch (error) {
      exibirLogs && console.error("Erro ao atualizar redes sociais:", error);
      toast.error(error.response?.data?.error || "Erro ao atualizar redes sociais.");
    }
  };

  return (
    <div className="solicitacoesContainer">
      <h3 className="titleAprovacao">Pedidos de aprovação</h3>
      <Row className="mb-3">
        <Col md={4} sm={12} xs={12}>
          <FormGroup>
            <Label>Buscar</Label>
            <Input
              type="search"
              value={search}
              placeholder="Nome, Email ou Telefone"
              onChange={(e) => {
                setPage(1);
                setSearch(e.target.value);
              }}
            />
          </FormGroup>
        </Col>

        <Col md={2} sm={12} xs={12}>
          <FormGroup>
            <Label>Status de Aprovação</Label>
            <Input
              type="select"
              value={statusAprovacao}
              onChange={(e) => {
                setPage(1);
                setStatusAprovacao(e.target.value);
              }}
            >
              <option value="Aprovado">Aprovado</option>
              <option value="Não Aprovado">Não Aprovado</option>
              <option value="Análise">Análise</option>
            </Input>
          </FormGroup>
        </Col>

        <Col md={2} sm={12} xs={12}>
					{search && (
						<Button
							className="w-fit w-sm-auto"
							color="secondary"
							onClick={fetchData}
							style={{ marginTop: 26 }}
						>
							<FiSearch size={22} />
						</Button>
					)}
        </Col>
      </Row>

      <div style={{ marginTop: 15, marginBottom: 10 }}>
        <span
          style={{
            fontWeight: "bold",
            color: "#6d6d6d",
          }}
        >
          Total de solicitações: {totalDocs}
        </span>
      </div>

      <Table striped responsive>
        <thead>
          <tr>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSortField("nome");
                setSortOrder(sortOrder === "asc" ? "desc" : "asc");
              }}
            >
              Nome{" "}
              {sortField === "nome" &&
                (sortOrder === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSortField("email");
                setSortOrder(sortOrder === "asc" ? "desc" : "asc");
              }}
            >
              E-mail{" "}
              {sortField === "email" &&
                (sortOrder === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
            </th>
            <th>Tipo de conta</th>
            <th>Telefone</th>
            <th>CPF/CNPJ</th>
            <th>Cidade/Estado</th>
            {userData?.tipoConta !== "automacao" && <th>Docs</th>}
            {userData?.tipoConta !== "automacao" && <th>Ações</th>}
          </tr>
        </thead>
        <tbody>
          {solicitacoes.map((solicitacao, index) => (
            <tr key={index}>
              <td>{solicitacao.nome}</td>
              <td>{solicitacao.email}</td>
              <td>
                {solicitacao.tipoConta === "usuario"
                  ? "Cortador"
                  : solicitacao.tipoConta}
              </td>
              <td>{formatPhone(solicitacao.telefone)}</td>
              <td>{formatCpfCnpj(solicitacao.cpfCnpj)}</td>
              <td>{`${solicitacao.cidade}/${solicitacao.estado}`}</td>
              {userData?.tipoConta !== "automacao" && (
                <>
                  <td>
                    <Button
                      color="primary"
                      outline
                      size="sm"
                      onClick={() =>
                        handleOpenDocs(
                          solicitacao.documentoFrente,
                          solicitacao.documentoVerso,
                          solicitacao.nome,
                          formatCpfCnpj(solicitacao.cpfCnpj)
                        )
                      }
                    >
                      <FaFileAlt />
                    </Button>
                  </td>
                  <td>
                    {userData?.tipoConta !== "automacao" ? (
                      <>
                        {solicitacao.redesSociais && solicitacao.redesSociais.length > 0 ? (
                          <Button
                            color="primary"
                            outline
                            size="sm"
                            onClick={() => handleAbrirModalRedes(solicitacao)}
                            disabled={userData?.tipoConta === "financeiro"}
                          >
                            <FaGlobe />
                          </Button>
                        ) : (
                          <Button 
                            onClick={() => handleAbrirModalRedes(solicitacao)} 
                            color="secondary" 
                            outline size="sm" 
                          >
                            <FaEyeSlash />
                          </Button>
                        )}
                      </>
                    ) : (
                      <FiLock size={22} />
                    )}
                  </td>
                  <td>
                    <Button
                      color="success"
                      size="sm"
                      className="me-2"
                      onClick={() => approveUser(solicitacao.uid)}
                    >
                      Aprovar
                    </Button>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => {
                        setUidParaReprovar(solicitacao.uid);
                        setShowMotivoModal(true);
                      }}
                    >
                      Recusar
                    </Button>
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 5,
        }}
      >
        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>

        {Array.from({ length: totalPages }, (_, i) => (
          <PaginationItem active={page === i + 1} key={i}>
            <PaginationLink onClick={() => setPage(i + 1)}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem disabled={page >= totalPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>
      </Pagination>

      <ModalDocumentos
        isOpen={showDocsModal}
        toggle={() => setShowDocsModal(false)}
        frente={docFrente}
        verso={docVerso}
        nome={nome}
        cpfCnpj={cpfCnpj}
      />

      <ModalMotivos
        isOpen={showMotivoModal}
        toggle={() => setShowMotivoModal(false)}
        uid={uidParaReprovar}
        onConfirm={async (uid, motivo) => {
          await repproveUser(uid, motivo);
        }}
      />

      <ModalListaDeRedes
        isOpen={modalRedesAberto}
        toggle={() => setModalRedesAberto(false)}
        redes={redesSelecionadas}
        onSave={handleSalvarRedes}
      />
    </div>
  );
}

export default Solicitacoes;
